import React, { useState, useEffect } from 'react';
import { useNavigate, Routes, Route, useLocation } from 'react-router-dom';
import DashboardContent from './DashboardContent';
import { LayoutDashboard, Users, MessageSquare, User, BookOpen } from 'lucide-react';
import Patients from './Patients';
import Messages from './MessagesFeature';
import PatientDetails from './PatientDetails';
import MessageDetail from './MessagesFeature/MessageDetail';
import AccountSettings from './AccountSettings';
import Resources from './Resources';
import { useSocket } from '../Context/SocketContext';
import DashboardShell from './Components/DashboardShell';
import NewSimulationModal from './Components/NewSimulation';

const ACCOUNT_ITEM = { id: 'account-settings', label: 'Account', icon: User, route: 'account-settings' };

const DashboardHome = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = useState('dashboard');
    const [simulationOpen, setSimulationOpen] = useState(false);
    /* Bumped after a save so the overview refetches and the new patient shows up. */
    const [savedCount, setSavedCount] = useState(0);
    const { unreadCount } = useSocket();

    useEffect(() => {
        const path = location.pathname;
        if (path.includes('/patients')) {
            setActivePage('patients');
        } else if (path.includes('/messages')) {
            setActivePage('messages');
        } else if (path.includes('/resources')) {
            setActivePage('resources');
        } else if (path.includes('/account-settings')) {
            setActivePage('account-settings');
        } else {
            setActivePage('dashboard');
        }
    }, [location.pathname]);

    const navItems = [
        { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, route: '' },
        { id: 'patients', label: 'Patients', icon: Users, route: 'patients' },
        { id: 'messages', label: 'Messages', icon: MessageSquare, route: 'messages', badge: unreadCount },
        { id: 'resources', label: 'Resources', icon: BookOpen, route: 'resources' },
    ];

    const handleNavigate = (item) => {
        setActivePage(item.id);
        navigate(item.route);
    };

    return (
        <DashboardShell
            navItems={navItems}
            accountItem={ACCOUNT_ITEM}
            activePage={activePage}
            onNavigate={handleNavigate}
            onNewSimulation={() => setSimulationOpen(true)}
        >
            {simulationOpen && (
                <NewSimulationModal
                    onClose={() => setSimulationOpen(false)}
                    onSaved={() => setSavedCount((count) => count + 1)}
                />
            )}
            <Routes>
                <Route
                    path="/"
                    element={
                        <DashboardContent
                            refreshKey={savedCount}
                            onNewSimulation={() => setSimulationOpen(true)}
                        />
                    }
                />
                <Route path="patients" element={<Patients />} />
                <Route path="patients/:id" element={<PatientDetails />} />
                <Route path="messages" element={<Messages />} />
                <Route path="messages/:chatToken" element={<MessageDetail />} />
                <Route path="resources" element={<Resources />} />
                <Route path="account-settings" element={<AccountSettings />} />
            </Routes>
        </DashboardShell>
    );
};

export default DashboardHome;
